import { cloneDeep } from 'lodash'
import {
  ADD_WIDGET,
  REMOVE_WIDGET,
  UPDATE_WIDGET,
  UPDATE_WIDGET_GRID_LAYOUT,
  UPDATE_WIDGET_GRID,
  SET_WIDGET_GRID_CONFIG,
  SET_DEFAULT_WIDGET_GRID_CONFIG,
} from '../../constants/types'

import { LAYER_TYPE_DEMOGRAPHIC } from '../../constants/layer-types'

import cardConfig from '../../common-components/widgets/current-card-config'


export const Reducer = (state = {}, { type, payload = {} }) => {
  const { layerID, layerType } = payload
  let widgets
  switch (type) {
  case ADD_WIDGET: {
    const { newWidget } = payload
    const layerTypeConfig = state[layerType] || []
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      return {
        ...state,
        [layerType]: [
          ...layerTypeConfig,
          newWidget,
        ],
      }
    }
    return {
      ...state,
      [layerType]: {
        ...state[layerType],
        [layerID]: [
          ...state[layerType][layerID],
          newWidget,
        ],
      },
    }
  }
  case REMOVE_WIDGET: {
    const { id } = payload
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      widgets = state[layerType]
    } else {
      widgets = state[layerType][layerID]
    }
    const newWidgets = widgets.filter((w) => w.id !== id)
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      return {
        ...state,
        [layerType]: [
          ...newWidgets,
        ],
      }
    }
    return {
      ...state,
      [layerType]: {
        ...state[layerType],
        [layerID]: [
          ...newWidgets,
        ],
      },
    }
  }
  case UPDATE_WIDGET:
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      widgets = cloneDeep(state[layerType])
    } else {
      widgets = cloneDeep(state[layerType][layerID])
    }
    widgets[payload.index] = {
      ...widgets[payload.index],
      ...payload.update,
    }
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      return {
        ...state,
        [layerType]: [
          ...widgets,
        ],
      }
    }
    return {
      ...state,
      [layerType]: {
        ...state[layerType],
        [layerID]: [
          ...widgets,
        ],
      },
    }
  case UPDATE_WIDGET_GRID_LAYOUT: {
    const { newOrder } = payload
    const newWidgetConfig = cloneDeep(newOrder)
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      return {
        ...state,
        [layerType]: [
          ...newWidgetConfig,
        ],
      }
    }
    return {
      ...state,
      [layerType]: {
        ...state[layerType],
        [layerID]: [
          ...newWidgetConfig,
        ],
      },
    }
  }
  case UPDATE_WIDGET_GRID:
    return {
      ...state,
      [layerType]: [
        ...payload.config,
      ],
    }
  case SET_DEFAULT_WIDGET_GRID_CONFIG: {
    if (layerType !== LAYER_TYPE_DEMOGRAPHIC) {
      const defaultConfig = cloneDeep(cardConfig[layerType])
      return {
        ...state,
        [layerType]: [
          ...defaultConfig,
        ],
      }
    }
    const defaultConfig = cloneDeep(cardConfig[layerType][layerID])
    return {
      ...state,
      [layerType]: {
        ...state[layerType],
        [layerID]: [
          ...defaultConfig,
        ],
      },
    }
  }
  case SET_WIDGET_GRID_CONFIG:
    return payload
  default:
    return state
  }
}
